import {
  Group,
  Text,
  Code,
  Paper,
  Badge,
  NumberFormatter,
  Tooltip,
} from "@mantine/core";
import Markdown from "../_Common/Markdown";
import CopyTextActionIcon from "./CopyTextActionIcon";
import UsageDetails from "../_Shared/UsageDetails";
import CitationsList from "../_Common/CitationsList";

export default function ResponseDetails({ response, request, displayMode }) {
  if (!response)
    return (
      <Paper radius="md" mb="sm" p="sm" withBorder bg="red.9">
        {request?.model && (
          <Badge size="xs" color="red" variant="light" radius="sm" mb={6}>
            {request.model}
          </Badge>
        )}
        <Text size="sm">No response — the request failed.</Text>
      </Paper>
    );

  const isError = !response.textResponse && !!response.verbatimResponse;
  const displayText = response.textResponse || response.verbatimResponse || "";

  return (
    <Paper radius="md" mb="sm" p="sm" pt={4} withBorder bg={isError ? "red.9" : undefined}>
      <Group
        style={{ borderBottom: "1px solid var(--mantine-color-gray-8)" }}
        pb={5}
        justify="space-between"
      >
        <Badge size="xs" color={isError ? "red" : "grape"} variant="light" radius="sm">
          {response.provider} / {response.model}
        </Badge>

        <Tooltip label={<UsageDetails usage={response.usage} />} multiline>
          <Text fz="xs">
            <NumberFormatter
              suffix="¢"
              decimalScale={4}
              value={response.usage?.costUsd * 100}
            />
          </Text>
        </Tooltip>
        <Badge size="xs" variant="light">
          <NumberFormatter
            suffix="ms"
            thousandSeparator
            value={response.milliseconds}
          />
        </Badge>

        <CopyTextActionIcon size="xs" text={displayText} />
      </Group>
      <div className="markdown">
        {displayMode == "markdown" && (
          <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            <Markdown>{displayText}</Markdown>
          </div>
        )}
        {displayMode == "mono" && (
          <Code style={{ whiteSpace: "pre-wrap" }} block>
            {displayText}
          </Code>
        )}
        {displayMode == "raw" && (
          <Text style={{ whiteSpace: "pre-wrap" }}>
            {displayText}
          </Text>
        )}
      </div>
      <CitationsList citations={response.citations} />
    </Paper>
  );
}
